const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.startOutputBuffer();
                if ((context.has(`align`) ? context.get(`align`) : null)) {
                    this.echo(`--logo-align: `);
                    this.echo(this.env.getFilter('escape').traceableCallable(3, this.source)(...[this.env, (context.has(`align`) ? context.get(`align`) : null), `html`, null, true]));
                    this.echo(`;`);
                }
                if ((context.has(`justify`) ? context.get(`justify`) : null)) {
                    this.echo(`--logo-justify: `);
                    this.echo(this.env.getFilter('escape').traceableCallable(6, this.source)(...[this.env, (context.has(`justify`) ? context.get(`justify`) : null), `html`, null, true]));
                    this.echo(`;`);
                }
                if ((context.has(`scale`) ? context.get(`scale`) : null)) {
                    this.echo(`--logo-scale: `);
                    this.echo(this.env.getFilter('escape').traceableCallable(9, this.source)(...[this.env, (context.has(`scale`) ? context.get(`scale`) : null), `html`, null, true]));
                    this.echo(`;`);
                }
                context.proxy[`_style`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
<div class="c-logo`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(13, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`"`);
                if ((context.has(`_style`) ? context.get(`_style`) : null)) {
                    this.echo(` style="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(14, this.source)(...[this.env, (context.has(`_style`) ? context.get(`_style`) : null), `html`, null, true]));
                    this.echo(`"`);
                }
                this.echo(`>
  `);
                this.traceableDisplayBlock(15, this.source)('content', context.clone(), blocks);
                this.echo(`</div>
`);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <img src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(16, this.source)(...[this.env, (context.has(`src`) ? context.get(`src`) : null), `html`, null, true]));
                this.echo(`" alt="`);
                this.echo(this.env.getFilter('escape').traceableCallable(16, this.source)(...[this.env, (context.has(`alt`) ? context.get(`alt`) : null), `html`, null, true]));
                this.echo(`"`);
                if ((context.has(`width`) ? context.get(`width`) : null)) {
                    this.echo(` width="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(17, this.source)(...[this.env, (context.has(`width`) ? context.get(`width`) : null), `html`, null, true]));
                    this.echo(`"`);
                }
                if ((context.has(`height`) ? context.get(`height`) : null)) {
                    this.echo(` height="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(18, this.source)(...[this.env, (context.has(`height`) ? context.get(`height`) : null), `html`, null, true]));
                    this.echo(`"`);
                }
                this.echo(`>
  `);
            }

            getTemplateName() {
                return `5c5990243a411de9cfd2e79cd2d119ff1ab6b9f83d0925f038b1af878fa587ca`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `5c5990243a411de9cfd2e79cd2d119ff1ab6b9f83d0925f038b1af878fa587ca`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '5c5990243a411de9cfd2e79cd2d119ff1ab6b9f83d0925f038b1af878fa587ca');

let template = env.loadTemplate('5c5990243a411de9cfd2e79cd2d119ff1ab6b9f83d0925f038b1af878fa587ca');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/logo/logo.twig", args: context }
     );
     return rendered;;
};